var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "receiptForm",
          attrs: { model: _vm.params, rules: _vm.rules, size: "small" },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("GlobalSetObj.client"),
                prop: "customerId",
              },
            },
            [
              _c("CustomerSelectCmp", {
                staticStyle: { width: "100%" },
                attrs: { "is-all": false },
                on: {
                  change: function (val) {
                    return (_vm.params.customerId = val)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("receivablePayable.statementType"),
                prop: "statementType",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: _vm.$t("operationCenter.PleaseSelect"),
                    clearable: "",
                    size: "small",
                    filterable: "",
                  },
                  model: {
                    value: _vm.params.statementType,
                    callback: function ($$v) {
                      _vm.$set(_vm.params, "statementType", $$v)
                    },
                    expression: "params.statementType",
                  },
                },
                _vm._l(_vm.EXPRESS_TYPE, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("receivablePayable.BillingDate"),
                prop: "time",
              },
            },
            [
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  type: "daterange",
                  "start-placeholder": _vm.$t("operationCenter.startDate"),
                  "end-placeholder": _vm.$t("operationCenter.endDate"),
                  "value-format": "yyyy-MM-dd",
                },
                model: {
                  value: _vm.params.time,
                  callback: function ($$v) {
                    _vm.$set(_vm.params, "time", $$v)
                  },
                  expression: "params.time",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex-c" },
        [
          _c(
            "el-button",
            {
              staticStyle: { margin: "0 10px 10px 0" },
              attrs: {
                icon: "el-icon-download",
                size: "small",
                type: "primary",
              },
              on: { click: _vm.operationBtn },
            },
            [_vm._v(_vm._s(_vm.$t("receivablePayable.DownloadTheTemplate")))]
          ),
          _c("upload-excel", {
            attrs: {
              "on-success": _vm.importLogistics,
              "but-name": _vm.$t("receivablePayable.ImportFile"),
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }